module.exports = __webpack_public_path__ + "img/featur_3.1d83d15d.jpg";